WB.Utility = WB.Utility || {};

import jsSHA from 'jssha';

/*
 * Intercepts http request and adds HMAC authentication, if the $http request
 * provides "hmac: true" as an option.
 */
WB.Utility.HMACInterceptor = function($q, _Config) {
    return {
        'request': function(config) {
            if (!config.hmac) {
                return config;
            }

            let parsedUri = new URL(config.url);
            let timestamp = Math.round(new Date().getTime() / 1000.0);
            let queryStrings = [];

            let keys = Object.keys(config.params);
            keys.sort(function (a, b) {
                return a.toLowerCase().localeCompare(b.toLowerCase());
            });

            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (config.params.hasOwnProperty(key)) {
                    queryStrings.push(key + '\n' + config.params[key]);
                }
            }

            var dataToHash = config.method + '\n'
                             + parsedUri.pathname + '\n'
                             + (config.data || '') + '\n'
                             + timestamp;

            if (queryStrings.length > 0) {
                dataToHash += '\n' + queryStrings.join('\n');
            }

            // Construct hash
            var shaObj = new jsSHA(dataToHash, 'TEXT'),
                    hmac = shaObj.getHMAC(_Config.Pulse.Secret, 'TEXT', 'SHA-256', 'B64');

            config.params.authid = _Config.Pulse.ID;
            config.params.timestamp = timestamp;
            config.params.hash = hmac;

            return config;
        }
    };
};
WB.Utility.HMACInterceptor.$inject = ['$q', '_Config'];
WB.Core.factory('HMACInterceptor', WB.Utility.HMACInterceptor);
